module.exports = __webpack_public_path__ + "static/media/gameEnd_1.011e73c8.mp3";